import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=510ccd0e&scoped=true"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"
import style0 from "./Overview.vue?vue&type=style&index=0&id=510ccd0e&prod&lang=scss&scoped=true"
import style1 from "./Overview.vue?vue&type=style&index=1&id=510ccd0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510ccd0e",
  null
  
)

export default component.exports